import { AuthService } from './../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { NgxRolesService } from 'ngx-permissions';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {
  url = ['/'];
  routeBase: string;
  isSchool: boolean;
  constructor(
    private router: Router,
    private authService: AuthService,
    private route: ActivatedRoute,
    private roleService: NgxRolesService,
  ) { 
    this.routeBase = 'school';
    this.isSchool = false;
  }

  ngOnInit() {
    this.route.data
      .subscribe((data: { isSchool: boolean }) => {
        this.routeBase = data.isSchool ? 'school' : 'pro';
        this.isSchool = data.isSchool;
      });
    if (this.roleService.getRole('ROLE_ADMIN') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      this.url = ['/admin/login'];
    } else {
      this.url = ['/login/'+this.routeBase];
    }
    this.authService.logout();
    this.router.navigate(this.url, { queryParams: this.route.snapshot.queryParams });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/logout/logout.component.ts